import { Box, Button, Stack, Typography } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircleOutline';
import { useTranslation } from 'react-i18next';

export function SubmitSuccess({ onReset }: { onReset: () => void }) {
  const { t } = useTranslation();

  return (
    <Box
      role="status"
      aria-live="polite"
      sx={{
        textAlign: 'center',
        py: { xs: 5, md: 7 },
        px: 3,
        border: 1,
        borderColor: 'divider',
        borderRadius: 3.5,
      }}
    >
      <Stack spacing={2} alignItems="center">
        <CheckCircleIcon sx={{ fontSize: 46 }} />
        <Typography variant="h3">{t('form.successTitle')}</Typography>
        <Typography color="text.secondary" sx={{ maxWidth: 460 }}>
          {t('form.successBody')}
        </Typography>
        <Button onClick={onReset} variant="outlined" color="inherit" sx={{ mt: 1 }}>
          {t('form.another')}
        </Button>
      </Stack>
    </Box>
  );
}
